import { Scene } from "phaser";

export class Boot extends Scene {
  constructor() {
    super("Boot");
  }

  preload() {
    //  The Boot Scene is typically used to load in any assets you require for your Preloader, such as a game logo or background.
    //  The smaller the file size of the assets, the better, as the Boot Scene itself has no preloader.
    // Menu
    this.load.image("bginit", "assets/menu-items/FondoInicio.jpg");
    this.load.image("bgend", "assets/menu-items/FondoFinal.jpg");
    this.load.image("seagull", "assets/menu-items/Gaviota.png");
    this.load.image("logovdb", "assets/menu-items/LogoVDB.png");
    this.load.image("logoexplora", "assets/menu-items/LogoExplora.png");
    // Interface
    this.load.image("startBtnOff", "assets/interface/ComenzarOFF.png");
    this.load.image("startBtnOn", "assets/interface/ComenzarON.png");
    this.load.image("map", "assets/map.png");
  }

  create() {
    this.scene.start("Preloader");
  }
}
